import { Injectable } from '@angular/core';
import { PerEmployeeCardsModel } from '../per-employee-cards/model/per-employee-cards-model';
import { PerEmployeeCardsService } from '../per-employee-cards/service/per-employee-cards-service';
import { PerEmployeeCardsQueryModel } from '../per-employee-cards/model/per-employee-cards-query-model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HvlSecurityService } from '@hvlng/framework-bff/security';

@Injectable({
    providedIn: 'root',
})
export class EmployeeCardLocalService {
    private employeeCards: PerEmployeeCardsModel[] = null;

    constructor(private perEmployeeCardsService: PerEmployeeCardsService, private securityService: HvlSecurityService) {
        this.securityService.isUserLoggedOut.subscribe({
            next: () => {
                this.employeeCards = null;
            },
        });
    }

    public getEmployeeCards(): Observable<PerEmployeeCardsModel[]> {
        if (this.employeeCards && this.employeeCards.length > 0)
            return of(this.employeeCards);

        let qm = new PerEmployeeCardsQueryModel();
        qm.includeCardCodeTextData = true;

        return this.perEmployeeCardsService.queryList(qm).pipe(map((res) => {
            this.employeeCards = res;
            return res;
        }));
    }

}
